<template>
  <div class="building-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="building-content">
      <h4 class="building-h4 indent" id="building-overview">Overview</h4>
      <p class="building-p indent">Aluminium is now utilised for a host of applications in building and construction and is the material of choice for curtain walling, window frames and other glazed structures. It is extensively used for rolling blinds, doors, exterior cladding and roofing, suspended ceilings, wall panels and partitions, heating and ventilation equipment, solar shading devices, light reflectors and complete prefabricated buildings. Structures like offshore living quarters, helicopter decks, balustrades, scaffolding and ladders, are also commonly made of aluminium.</p>
      <p class="building-p indent">At Alcomet we manufacture customized extrusion solutions for your own building systems as well as a wide range of rolled products, such as aluminium foil, sheets and coils for building applications.</p>
      <div class="building-img" :style="{backgroundImage: 'url(' + '/static/img/markets/building/img_1.jpg' + ')'}"></div>
      <h4 class="building-h4 indent" id="building-facades">Facades</h4>
      <p class="building-p indent">Building façades are one of the largest, most important elements in the overall aesthetic and technical performance of a building. Aluminium gives much needed liberty to new-age architects in terms of design while catering to the changing preferences of consumers worldwide. Aluminium profiles and glass provide the perfect combination to ensure a high level of natural lighting inside buildings.</p>
      <p class="building-p indent">Curtain walling is building façade system normally made of aluminium, glass and other composite materials, forming a lightweight structure.</p>
      <p class="building-p indent">Curtain walls are used in all types of buildings, with advantages including a reduced construction period, low cost low weight and strong performance. Aluminium is the material best suited to realizing energy efficiency in curtain wall systems, in terms of allowing daylight in and reducing building cooling costs.</p>
      <p class="building-p indent">Intelligent facades incorporating aluminium systems can decrease energy consumption in buildings by up to 50%. The key feature of these intelligent buildings is their optimized interaction with the exterior, markedly reducing heating, cooling, ventilation and lighting energy demands throughout the seasons.</p>
      <p class="building-p indent">In its extrusion plant Alcomet is able to extrude a large variety of profiles for building applications according to your design. Contact us with your enquiry today.</p>
      <div class="building-img" :style="{backgroundImage: 'url(' + '/static/img/markets/building/img_2.jpg' + ')'}"></div>
      <h4 class="building-h4 indent" id="building-wad">Windows and doors</h4>
      <p class="building-p indent">Aluminium windows provide many benefits over other equivalents. Resistance, easy maintenance, modern appearance available in an infinite colour range, excellent sound insulation are just a few of them. Aluminium glazing affords customers minimal, slim profiles that maximise external views – ideal for those wishing to make the most of their countryside landscape.</p>
      <p class="building-p indent">Aluminium windows can easily achieve improvements in heat gain and heat loss by as much as 60 per cent when combined with a thermal break and meet even the highest energy efficiency standards making them a preferred element in modern architecture.</p>
      <p class="building-p indent">From beautiful, bespoke sliding patio doors to lift and slide doors, the range of aluminium sliding doors available allows architects to create a unique look for your property, whatever the building style. Due to their combination of strength and durability aluminium doors can be over 3 metres high, letting the maximum amount of glorious light into your building.</p>
      <p class="building-p indent">In its extrusion plant Alcomet is able to extrude a large variety of profiles for building applications according to your design. Contact us with your enquiry today</p>
      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["building-overview", "Overview"],
        ["building-facades", "Facades"],
        ["building-wad", "Windows and doors"]
      ]
    };
  }
};
</script>

<style scoped>
.building-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.building-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.building-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.building-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.building-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 500px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .building-content {
    width: 100%;
  }
  .building-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .building-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .building-img {
    background-attachment: fixed;
    border-radius: 0;
    min-height: 30vw;
    margin: 20px 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Building.vue